import React from 'react';
import {
    FormattedMessage,
    injectIntl,
    WrappedComponentProps,
} from 'react-intl';
import core from '@gin-betting/core';
import { Severity } from '@sentry/types';

import { isMobile } from 'app-constants';
import { Icon, Portal } from 'components';
import messages from './messages-sync';
import globalMessages from 'messages';
import arrowDownCircle from 'assets/svg/arrow-down-circle.svg';

// Don't change css imports
/* eslint-disable  */
import * as container from '../components/BetslipList/betslipList.scss';
import * as header from '../components/BetslipHeader/betslipHeader.scss';
import * as betslip from '../components/Betslip/betslip.scss';

const { measureTime } = core.utils;
const { sentryHub } = core.services;

// TODO: remove unused expressions; investigate
// right now this is required so webpack do not trim "unused" imports
/* tslint:disable:no-unused-expression */
container;
header;
betslip;
/* eslint-enable */

interface OwnProps {
    withoutPortal?: boolean;
}
interface MappedProps {}

type Props = OwnProps & MappedProps & WrappedComponentProps;

class BetslipStub extends React.Component<Props> {
    styleName = 'container.container container.is-disabled';
    className = '__app-BetslipContainer-container';

    handleOpenClick = () => {
        measureTime('betslipStubClicked');
        sentryHub.captureMessage(
            'Attempt to open betslip before the module is loaded',
            Severity.Warning
        );
    };

    renderBody = () => {
        const {
            intl: { formatMessage },
        } = this.props;

        return (
            <div styleName="betslip.betslip">
                <div
                    styleName="header.header header.is-active"
                    onClick={this.handleOpenClick}
                >
                    <span styleName="header.title">
                        <FormattedMessage
                            {...(isMobile
                                ? messages.bettingSlipMobile
                                : globalMessages.bettingSlip)}
                        />
                    </span>

                    <div styleName="header.button-wrapper">
                        <span styleName="header.label">
                            0
                            {!isMobile &&
                                formatMessage(
                                    globalMessages.bettingSlipBetTitle,
                                    {
                                        count: 0,
                                    }
                                )}
                        </span>

                        <Icon
                            styleName="header.icon header.icon-arrow header.is-closed header.is-disabled"
                            glyph={arrowDownCircle}
                            title="Loading..."
                        />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { withoutPortal } = this.props;

        if (withoutPortal) {
            return (
                <div styleName={this.styleName} className={this.className}>
                    {this.renderBody()}
                </div>
            );
        }

        return (
            <Portal
                styleName={this.styleName}
                className={this.className}
                isPageDisabled={false}
            >
                {this.renderBody()}
            </Portal>
        );
    }
}

export default injectIntl(BetslipStub);
